import React, { useState } from "react";

export default function Contact() {
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    try {
      const formData = new FormData(form);
      await fetch("/", {
        method: "POST",
        body: formData,
      });
      setStatus("Thanks! Your message has been sent.");
      form.reset();
    } catch (error) {
      setStatus("Oops! Something went wrong.");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-[#fdf9f6] px-4">
      <form
        name="contact"
        method="POST"
        data-netlify="true"
        onSubmit={handleSubmit}
        className="bg-white w-full max-w-2xl shadow-2xl rounded-2xl p-6 sm:p-10"
      >
        {/* hidden Netlify input */}
        <input type="hidden" name="form-name" value="contact" />

        <h2 className="text-2xl sm:text-3xl font-semibold text-center text-[#007B7F] mb-6 sm:mb-8 font-perandory">
          Get in Touch with us
        </h2>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Name</label>
          <input
            type="text"
            name="name"
            required
            className="w-full border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Email</label>
          <input
            type="email"
            name="email"
            required
            className="w-full border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Message</label>
          <textarea
            name="message"
            rows="4"
            required
            className="w-full border border-gray-300 rounded-md px-3 py-2"
          ></textarea>
        </div>

        <button
          type="submit"
          className="w-full bg-[#007B7F] text-white font-semibold py-2 rounded-md hover:bg-[#14767E] hover:text-white transition"
        >
          Send Message
        </button>

        {status && (
          <p className="mt-4 text-center text-sm text-green-600">{status}</p>
        )}
      </form>
    </div>
  );
}
